import { jssPreset } from '@material-ui/core/styles';

import type { JssOptions, Jss } from 'jss';
import { create } from 'jss';
import rtl from 'jss-rtl';

const jss = (options?: Partial<JssOptions>): Jss =>
  create({
    ...options,
    plugins: [...jssPreset().plugins, rtl()],
  });

export default jss;
